module.exports = __webpack_public_path__ + "static/img/9.040c6a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/zh/9.png
// module id = ngA4
// module chunks = 0